import type { TemplateTier } from '@/types/template';

/**
 * Get display name for a tier
 */
export function getTierDisplayName(tier: TemplateTier | undefined | null): string {
  if (!tier) return 'Standard';
  const names: Record<TemplateTier, string> = {
    standard: 'Standard',
    premium: 'Premium',
  };
  return names[tier] ?? tier;
}

/**
 * All available tiers in order
 */
export const TIERS: TemplateTier[] = ['standard', 'premium'];

/**
 * Monthly price per tier, in cents (Stripe `unit_amount` convention).
 *
 * The source of truth is the Stripe prices with lookup_keys
 * `site_standard_monthly` / `site_premium_monthly` (resolved by
 * `priceIdForTier` in backend/src/services/stripe.service.ts) — keep this
 * mapping in sync with the Stripe dashboard.
 */
export const TIER_PRICING_CENTS: Record<TemplateTier, number> = {
  standard: 500,
  premium: 700,
};
